import { X, Send } from 'lucide-react'
import clsx from 'clsx'

interface ImageConfirmModalProps {
  pendingImage: { file: File; previewUrl: string }
  imageMethod: 'api' | 'ocr'
  imageModel: string
  onSetMethod: (method: 'api' | 'ocr') => void
  onSetModel: (model: string) => void
  onConfirm: () => void
  onCancel: () => void
}

const IMAGE_MODELS = [
  { id: 'gemini-2.5-flash', name: 'Gemini 2.5 Flash', desc: '빠르고 정확 (권장)' },
  { id: 'gemini-3-flash-preview', name: 'Gemini 3 Flash', desc: '최신 모델' },
  { id: 'gemini-2.5-pro', name: 'Gemini 2.5 Pro', desc: '최고 품질' },
  { id: 'claude-sonnet-4-20250514', name: 'Claude Sonnet 4', desc: '상세 분석' },
  { id: 'gpt-4o', name: 'GPT-4o', desc: 'OpenAI 최신' },
  { id: 'gpt-4o-mini', name: 'GPT-4o Mini', desc: '저비용' },
]

export function ImageConfirmModal({
  pendingImage, imageMethod, imageModel,
  onSetMethod, onSetModel, onConfirm, onCancel,
}: ImageConfirmModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60" onClick={onCancel}>
      <div className="bg-bg-primary border border-border-subtle rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-4 border-b border-border-subtle flex items-center justify-between">
          <h3 className="font-semibold text-lg">이미지 텍스트 추출</h3>
          <button onClick={onCancel} className="p-1 text-text-tertiary hover:text-text-primary"><X className="w-5 h-5" /></button>
        </div>
        <div className="px-5 py-4 space-y-4">
          <div className="flex justify-center bg-bg-elevated rounded-lg p-3">
            <img src={pendingImage.previewUrl} alt="미리보기" className="max-h-48 rounded object-contain" />
          </div>
          <p className="text-xs text-text-tertiary text-center">{pendingImage.file.name} ({(pendingImage.file.size / 1024).toFixed(0)} KB)</p>
          <div>
            <label className="block text-sm font-medium mb-2">추출 방식</label>
            <div className="flex gap-2">
              <button onClick={() => onSetMethod('api')} className={clsx('flex-1 text-sm px-3 py-2 rounded-lg border-2 transition-all', imageMethod === 'api' ? 'border-primary bg-primary/10 text-primary' : 'border-border-subtle text-text-secondary hover:border-text-tertiary')}>Image-to-Text API</button>
              <button onClick={() => onSetMethod('ocr')} className={clsx('flex-1 text-sm px-3 py-2 rounded-lg border-2 transition-all', imageMethod === 'ocr' ? 'border-primary bg-primary/10 text-primary' : 'border-border-subtle text-text-secondary hover:border-text-tertiary')}>Gemini OCR 직접</button>
            </div>
          </div>
          {imageMethod === 'api' && (
            <div>
              <label className="block text-sm font-medium mb-2">AI 모델</label>
              <div className="grid grid-cols-2 gap-2">
                {IMAGE_MODELS.map((m) => (
                  <button key={m.id} onClick={() => onSetModel(m.id)} className={clsx('text-left px-3 py-2 rounded-lg border-2 transition-all', imageModel === m.id ? 'border-primary bg-primary/10' : 'border-border-subtle hover:border-text-tertiary')}>
                    <span className="text-sm font-medium">{m.name}</span>
                    <p className="text-xs text-text-tertiary">{m.desc}</p>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="px-5 py-4 border-t border-border-subtle flex justify-end gap-2">
          <button onClick={onCancel} className="btn btn-ghost text-sm">취소</button>
          <button onClick={onConfirm} className="btn btn-primary text-sm flex items-center gap-2"><Send className="w-4 h-4" /> 텍스트 추출 시작</button>
        </div>
      </div>
    </div>
  )
}
